/**
 * @generated SignedSource<<580bfd18457a788798e876da7a5a8114>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateConnectInboxInput = {
  todoCategoryId: string;
};
export type useCreateConnectInboxMutation$variables = {
  input: CreateConnectInboxInput;
};
export type useCreateConnectInboxMutation$data = {
  readonly store: {
    readonly createConnectInbox: {
      readonly connectInbox: {
        readonly id: string;
      };
    };
  };
};
export type useCreateConnectInboxMutation = {
  response: useCreateConnectInboxMutation$data;
  variables: useCreateConnectInboxMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateConnectInboxPayload",
        "kind": "LinkedField",
        "name": "createConnectInbox",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConnectInbox",
            "kind": "LinkedField",
            "name": "connectInbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateConnectInboxMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateConnectInboxMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "74a08b337ce1c96cbcbd63c26d68e9b4",
    "id": null,
    "metadata": {},
    "name": "useCreateConnectInboxMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateConnectInboxMutation(\n  $input: CreateConnectInboxInput!\n) {\n  store {\n    createConnectInbox(input: $input) {\n      connectInbox {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae04a6becdfc82914fb266719e1709aa";

export default node;
